import styled from "@emotion/styled";
import ArrowDown from "../../../svgs/arrow-down.svg";

const StyledFaq = styled.details`
  border: 1px solid #e0e0e0;

  summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    list-style: none;
    padding: var(--mini) var(--xx-small);

    &::-webkit-details-marker,
    &::marker {
      display: none;
    }
  }

  .arrow {
    height: 24px;
    width: 24px;
    transition: all 0.2s;
  }

  &[open] {
    .arrow {
      transform: rotate(-180deg);
    }
  }

  .content {
   padding: 0 var(--xx-small) var(--mini);
  }

  p + p {
    margin-top: var(--mini);
  }

  ol {
    margin: var(--mini) 0;
    padding-left: var(--mini);
    max-width: 1000px;
  }

  li + li {
    margin-top: var(--nano);
  }
`;

export interface FaqProps {
  title: string;
  children: string | JSX.Element | JSX.Element[];
}

export const Faq = ({ title, children }: FaqProps) => (
  <StyledFaq>
    <summary>
      <h3 className="h3">{title}</h3>
      <img className="arrow" src={ArrowDown} alt="Arrow" />
    </summary>
    <div className="content">{children}</div>
  </StyledFaq>
);
